import type { R3InputNumberVue } from '#components';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';

export class CalculadoraDeCaixa {
	visible: Ref<boolean> = ref(false);
	total: Ref<number> = ref<number>(0);
	lastro: Ref<ComponentExposed<typeof R3InputNumber> | null> = ref(null);
	camada: Ref<ComponentExposed<typeof R3InputNumber> | null> = ref(null);
	caixaSolta: Ref<ComponentExposed<typeof R3InputNumber> | null> = ref(null);
}